'use client'
import { Mention, MentionsInput, SuggestionDataItem } from 'react-mentions'
import { Avatar } from '@nextui-org/avatar'

import { useApiGet } from '@/hooks/useApiGet'
import { useAppSelector } from '@/hooks'

import styles from './styles.module.css'

type AddCommentProps = {
  postId?: string
  refetchComment?: any
  value: any
  setValue: any
}

const AddComment: React.FC<AddCommentProps> = (props) => {
  const { value, setValue } = props
  const user = useAppSelector((state) => state.root.auth.user)

  // const [cursorPosition, setCursorPosition] = useState(0);

  // const [search, setSearch] = useState<string>('');

  // const [dataSearch, setDataSearch] = useState<SuggestionDataItem[]>([]);

  // const debouncedSearchName = useDebounce(search, 500);

  // const [, updateState] = useState({});

  // const forceUpdate = useCallback(() => updateState({}), []);

  // const { data: holdersData } = useGetHoldQuery({
  //     end: 'holder',
  //     page: 1,
  //     size: 30,
  //     search: debouncedSearchName ?? '',
  // });

  // useEffect(() => {
  //     if (!holdersData) return;

  //     const data = holdersData?.payload?.map((item) => ({
  //         id: item.id,
  //         display: item.nickname,
  //         avatarImage: item.avatarImage,
  //     }));
  //     setDataSearch(data);
  //     forceUpdate();
  // }, [holdersData]);

  const handleSearchUser = async (search: string, callback: (data: SuggestionDataItem[]) => void) => {
    try {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const res: any = await useApiGet(
        `${process.env.w3Url}/user?page=0&limit=30&optionOrder=none&keySearch=${search}`,
        true,
      )

      if (!res) return callback([])
      const data =
        (res?.data || []).map((item: { id: any; nickname: any; avatarImage: any }) => ({
          id: item.id,
          display: item.nickname,
          avatarImage: item.avatarImage || '',
        })) ?? []
      callback(data || [])
    } catch (error) {
      callback([])
      console.log(error)
    }
  }

  return (
    <form className={styles.add__comment__container}>
      <MentionsInput
        value={value}
        ref={() => {}}
        allowSpaceInQuery
        allowSuggestionsAboveCursor
        forceSuggestionsAboveCursor
        onChange={(e) => {
          setValue(e)

          // tìm phầm tử trước cursorPosition để xác định xem có phải là mention hay không dựa vào điều kiện có @ hay không
          // const splicedValue = newPlainTextValue.slice(0, cursorPosition);

          // const isMention = splicedValue.includes('@');
          // // console.log(mentions);

          // if (isMention) {
          //     const search = splicedValue.split('@').pop();
          //     const findMentioned = mentions.findIndex((mention) => `@${search}`.includes(mention.display));
          //     if (findMentioned === -1 && !!search?.length) {
          //         setSearch(search);
          //     }
          // }
        }}
        // onKeyUp={(e) => {
        //     //@ts-ignore
        //     const position = e.target.selectionStart;

        //     if (e.key === 'Backspace') {
        //         setCursorPosition(position);
        //     }

        //     setCursorPosition(position + 1);
        // }}
        // onClick={(e) => {
        //     //@ts-ignore
        //     const position = e.target.selectionStart;
        //     setCursorPosition(position);
        // }}

        className="mentions"
        classNames={styles}
        placeholder={`Comment as ${user?.nickname}`}
        a11ySuggestionsListLabel={'What’s on your mind?'}
      >
        <Mention
          appendSpaceOnAdd={true}
          markup="[@:__id__:__display__]"
          trigger="@"
          className={styles.mentions__mention}
          displayTransform={(_, display) => `@${display}`}
          // data={dataSearch}
          data={handleSearchUser}
          renderSuggestion={(suggestion, _, highlightedDisplay, index, focused) => {
            return (
              <>
                {index !== 0 && <span className="block w-full border-b-1 border-[#E4E4E4]" />}
                <div
                  className={`flex items-center gap-2 rounded-xl px-1 py-2 ${focused ? `bg-[#6C5DD3] text-white` : ''}`}
                >
                  <Avatar
                    //@ts-ignore
                    src={suggestion?.avatarImage}
                    className="w-[30px] h-[30px]"
                  />
                  {highlightedDisplay}
                </div>
              </>
            )
          }}
        />
      </MentionsInput>
    </form>
  )
}

export default AddComment
